import { VideoSource, getVideoSource } from "../../../../VideoPlayer/VideoPlayer.utils";
export const isUrlValid = videoLink => {
  try {
    const parsedVideoLink = new URL(videoLink);
    return getVideoSource(parsedVideoLink) !== VideoSource.Unsupported;
  } catch (err) {
    return false;
  }
};